import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

import languages from "./languages";

import enAmbassador from "./locales/en/ambassador.json";
import enCareers from "./locales/en/careers.json";
import enDashboardVideos from "./locales/en/dashboard_videos.json";
import enLicenses from "./locales/en/licenses.json";
import enFAQ from "./locales/en/faq.json";
import enFooter from "./locales/en/footer.json";
import enFormLabels from "./locales/en/form_labels.json";
import enHome from "./locales/en/home.json";
import enJoin from "./locales/en/join.json";
import enAccountTypes from "./locales/en/account_types.json";
import enLogin from "./locales/en/login.json";
import enTeam from "./locales/en/team.json";
import enTranslation from "./locales/en/translation.json";
import enWhysolar from "./locales/en/whysolar.json";
import enEnterpriseJoin from "./locales/en/enterprise_join.json";
import enEnterpriseSellerJoin from "./locales/en/enterprise_seller_join.json";
import enEnterpriseJoinFormLabels from "./locales/en/ent_join_form_labels.json";
import enSetterJoin from "./locales/en/setter_join.json";
import enStaticHome from "./locales/en/static_home.json";
import enStaticLayout from "./locales/en/static_layout.json";
import enStaticAbout from "./locales/en/static_about.json";
import enStaticAmbassadorPage from "./locales/en/static_ambassador_page.json";
import enStaticAmbassadorSignup from "./locales/en/static_ambassador_signup.json";
import enStaticCareers from "./locales/en/static_careers.json";
import enStaticDial from "./locales/en/static_dial.json";
import enStaticEnergyStorage from "./locales/en/static_energy_storage.json";
import enStaticEnterprise from "./locales/en/static_enterprise.json";
import enStaticEnterpriseSignup from "./locales/en/static_enterprise_signup.json";
import enStaticFaq from "./locales/en/static_faq.json";
import enStaticHomeLight from "./locales/en/static_home_light.json";
import enStaticLicenses from "./locales/en/static_licenses.json";
import enStaticPartners from "./locales/en/static_partners.json";
import enStaticPrivacyPolicy from "./locales/en/static_privacy_policy.json";
import enStaticQuoteModal from "./locales/en/static_quote_modal.json";
import enStaticSavingsWidget from "./locales/en/static_savings_widget.json";
import enStaticSellerSignup from "./locales/en/static_seller_signup.json";
import enStaticSellers from "./locales/en/static_sellers.json";
import enStaticUpgrade from "./locales/en/static_upgrade.json";
import enStaticWhySolar from "./locales/en/static_why_solar.json";

import esAmbassador from "./locales/es/ambassador.json";
import esCareers from "./locales/es/careers.json";
import esDashboardVideos from "./locales/es/dashboard_videos.json";
import esLicenses from "./locales/es/licenses.json";
import esFAQ from "./locales/es/faq.json";
import esFooter from "./locales/es/footer.json";
import esFormLabels from "./locales/es/form_labels.json";
import esHome from "./locales/es/home.json";
import esJoin from "./locales/es/join.json";
import esAccountTypes from "./locales/es/account_types.json";
import esLogin from "./locales/es/login.json";
import esTeam from "./locales/es/team.json";
import esTranslation from "./locales/es/translation.json";
import esWhysolar from "./locales/es/whysolar.json";
import esEnterpriseJoin from "./locales/es/enterprise_join.json";
import esEnterpriseSellerJoin from "./locales/es/enterprise_seller_join.json";
import esEnterpriseJoinFormLabels from "./locales/es/ent_join_form_labels.json";
import esSetterJoin from "./locales/es/setter_join.json";
import esStaticHome from "./locales/es/static_home.json";
import esStaticLayout from "./locales/es/static_layout.json";
import esStaticAbout from "./locales/es/static_about.json";
import esStaticAmbassadorPage from "./locales/es/static_ambassador_page.json";
import esStaticAmbassadorSignup from "./locales/es/static_ambassador_signup.json";
import esStaticCareers from "./locales/es/static_careers.json";
import esStaticDial from "./locales/es/static_dial.json";
import esStaticEnergyStorage from "./locales/es/static_energy_storage.json";
import esStaticEnterprise from "./locales/es/static_enterprise.json";
import esStaticEnterpriseSignup from "./locales/es/static_enterprise_signup.json";
import esStaticFaq from "./locales/es/static_faq.json";
import esStaticHomeLight from "./locales/es/static_home_light.json";
import esStaticLicenses from "./locales/es/static_licenses.json";
import esStaticPartners from "./locales/es/static_partners.json";
import esStaticPrivacyPolicy from "./locales/es/static_privacy_policy.json";
import esStaticQuoteModal from "./locales/es/static_quote_modal.json";
import esStaticSavingsWidget from "./locales/es/static_savings_widget.json";
import esStaticSellerSignup from "./locales/es/static_seller_signup.json";
import esStaticSellers from "./locales/es/static_sellers.json";
import esStaticUpgrade from "./locales/es/static_upgrade.json";
import esStaticWhySolar from "./locales/es/static_why_solar.json";

const lngs = Object.keys(languages);

const resources = {
  en: {
    ambassador: enAmbassador,
    careers: enCareers,
    dashboard_videos: enDashboardVideos,
    licenses: enLicenses,
    faq: enFAQ,
    footer: enFooter,
    form_labels: enFormLabels,
    home: enHome,
    join: enJoin,
    account_types: enAccountTypes,
    login: enLogin,
    team: enTeam,
    whysolar: enWhysolar,
    translation: enTranslation,
    enterprise_join: enEnterpriseJoin,
    ent_join_form_labels: enEnterpriseJoinFormLabels,
    enterprise_seller_join: enEnterpriseSellerJoin,
    setter_join: enSetterJoin,
    static_home: enStaticHome,
    static_layout: enStaticLayout,
    static_about: enStaticAbout,
    static_ambassador_page: enStaticAmbassadorPage,
    static_ambassador_signup: enStaticAmbassadorSignup,
    static_careers: enStaticCareers,
    static_dial: enStaticDial,
    static_energy_storage: enStaticEnergyStorage,
    static_enterprise: enStaticEnterprise,
    static_enterprise_signup: enStaticEnterpriseSignup,
    static_faq: enStaticFaq,
    static_home_light: enStaticHomeLight,
    static_licenses: enStaticLicenses,
    static_partners: enStaticPartners,
    static_privacy_policy: enStaticPrivacyPolicy,
    static_quote_modal: enStaticQuoteModal,
    static_savings_widget: enStaticSavingsWidget,
    static_seller_signup: enStaticSellerSignup,
    static_sellers: enStaticSellers,
    static_upgrade: enStaticUpgrade,
    static_why_solar: enStaticWhySolar,
  },
  es: {
    ambassador: esAmbassador,
    careers: esCareers,
    dashboard_videos: esDashboardVideos,
    licenses: esLicenses,
    faq: esFAQ,
    footer: esFooter,
    form_labels: esFormLabels,
    home: esHome,
    join: esJoin,
    account_types: esAccountTypes,
    login: esLogin,
    team: esTeam,
    whysolar: esWhysolar,
    translation: esTranslation,
    enterprise_join: esEnterpriseJoin,
    enterprise_seller_join: esEnterpriseSellerJoin,
    ent_join_form_labels: esEnterpriseJoinFormLabels,
    setter_join: esSetterJoin,
    static_home: esStaticHome,
    static_layout: esStaticLayout,
    static_about: esStaticAbout,
    static_ambassador_page: esStaticAmbassadorPage,
    static_ambassador_signup: esStaticAmbassadorSignup,
    static_careers: esStaticCareers,
    static_dial: esStaticDial,
    static_energy_storage: esStaticEnergyStorage,
    static_enterprise: esStaticEnterprise,
    static_enterprise_signup: esStaticEnterpriseSignup,
    static_faq: esStaticFaq,
    static_home_light: esStaticHomeLight,
    static_licenses: esStaticLicenses,
    static_partners: esStaticPartners,
    static_privacy_policy: esStaticPrivacyPolicy,
    static_quote_modal: esStaticQuoteModal,
    static_savings_widget: esStaticSavingsWidget,
    static_seller_signup: esStaticSellerSignup,
    static_sellers: esStaticSellers,
    static_upgrade: esStaticUpgrade,
    static_why_solar: esStaticWhySolar,
  },
};

const options = {
  // https://www.i18next.com/overview/configuration-options
  resources,
  fallbackLng: lngs[0],
  // debug: process.env.NODE_ENV === "development",
  supportedLngs: lngs,
  interpolation: {
    escapeValue: false,
  },
  react: {
    // https://react.i18next.com/latest/i18next-instance
    useSuspense: false,
  },
  detection: {
    order: ["querystring", "localStorage", "navigator", "cookie", "sessionStorage", "htmlTag", "path"],
  },
};

export default (lng) => {
  return new Promise((resolve, reject) => {
    if (i18n.isInitialized) {
      resolve(i18n);
    } else {
      i18n.use(Backend).use(initReactI18next).use(LanguageDetector);

      if (lng && lngs.includes(lng)) {
        options.lng = lng;
      }

      i18n
        .init(options)
        .then(() => resolve(i18n))
        .catch(reject);
    }
  });
};

export { default as languages } from "./languages";
